import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Login from './Components/Login';
import useToken from './Components/useToken';

import Dashboard from './Layouts/Dashboard';
import { siteTheme } from 'Components/SiteTheme';
import { CssBaseline, ThemeProvider } from '@mui/material';
import config from 'config/config'
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(config.muiProLicenseKey);

function App() {
    const { token, setToken } = useToken();


    return (
        <div className="wrapper">
            <ThemeProvider theme={siteTheme}>
            <CssBaseline/>

            <BrowserRouter >
                <Switch >
                    <Route path="/" >
                        { token ? (<Dashboard />) : (<Login setToken={setToken} />) }
                    </Route>
                </Switch>
            </BrowserRouter>
            </ThemeProvider>                        
        </div>
    );

}

export default App;